import React from 'react';
import { IonIcon } from '@ionic/react';
import { hourglassOutline } from 'ionicons/icons';
import { RelationStatus } from '../../model/models';

export interface DirectoryProps {
  friendStatus: RelationStatus;
}
function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

export const FRIEND_ACCEPTED_ICON = 'assets/img/friend.svg';
export const FRIEND_ADD_ICON = 'assets/img/add-friend.svg';

export const RELATION_STATUS_ICONS = {
  accepted: FRIEND_ACCEPTED_ICON,
  requested: hourglassOutline,
  refused: hourglassOutline, // same as requested (sender dont need to know it has been refused)
  default: FRIEND_ADD_ICON,
  none: '',
};

export const RELATION_STATUS_CLASSES = {
  accepted: 'hidden',
  requested: 'bg-[#FAD59B] text-white',
  refused: 'bg-gray-100 text-gray-500', // same as requested (sender dont need to know it has been refused)
  default: 'bg-primary text-white',
  none: 'hidden',
};

export const getIcon = (status: RelationStatus) => {
  if (status !== undefined) {
    return RELATION_STATUS_ICONS[status];
  } else {
    return RELATION_STATUS_ICONS['default'];
  }
};

export const getIconClasses = (status: RelationStatus) => {
  if (status !== undefined) {
    return RELATION_STATUS_CLASSES[status];
  } else {
    return RELATION_STATUS_CLASSES['default'];
  }
};

export const DirectoryIcon: React.FC<DirectoryProps> = (props) => (
  <div>
    <span
      className={classNames(
        getIconClasses(props.friendStatus),
        'border-transparent h-9 w-9 mt-0.5 cursor-pointer rounded-full border flex items-center justify-center md:h-8 md:w-8'
      )}
      aria-hidden="true"
    >
      <IonIcon icon={getIcon(props.friendStatus)}></IonIcon>
    </span>
  </div>
);
